import RestClient from '../../common/modules/rest';
import { API } from '../../common/settings';

const rest = new RestClient();
const serviceEndpoint = API.API_ENDPOINTS.SERVICES;
const categoriesEndpoint = API.API_ENDPOINTS.CATEGORIES;
const submitFormEndpoint = API.API_ENDPOINTS.SUBMIT_FORM;
const languageEndpoint = API.API_ENDPOINTS.LANGUAGES;
const autoEnrolmentEndpoint = API.API_ENDPOINTS.AUTO_ENROL;

export const fetchLanguages = () => rest.get(languageEndpoint);

export const fetchServices = () => rest.get(serviceEndpoint);

export const fetchCategories = () => rest.get(categoriesEndpoint);

export const checkAutoEnrolmentStatus = (params) => rest.post(autoEnrolmentEndpoint, params);

export const submitForm = (journey, params) => rest.post(`${submitFormEndpoint}${journey}`, params);
